// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from '@/store';
import ElementUI from 'element-ui'
import '@/assets/stylesheet/index.scss' // global css
import '@/assets/stylesheet/element-variables.scss'
import i18n from '@/locales'      // i18n 国际化
import '@/utils/flexible'
import VideoPlayer from 'vue-video-player'
import "animate.css";
import MessageBox from '@/components/messageBox/index';
import messageBoxTip from '@/components/messageBoxTip/index';
import abiltyBeginDialogNew from '@/components/abiltyBeginDialogNew/index';
import api from './api/index.js'
import preventReClick from '@/utils/preventReClick' //防多次点击，重复提交
import '@/assets/js/player.js'
import {message} from '@/utils/resetMessage';
import {customMessageBox,getUserAuthority,clearGlobalStorage} from '@/mixins';
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)
Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(MessageBox)
Vue.use(messageBoxTip)
Vue.use(abiltyBeginDialogNew)
Vue.mixin(customMessageBox)  // 弹窗封装
Vue.mixin(getUserAuthority)  // 权限封装，全局可调用
Vue.mixin(clearGlobalStorage)  // 缓存清除封装，全局可调用

Vue.prototype.$api = api
Vue.prototype.$EventBus = new Vue()
Vue.use(ElementUI)
Vue.prototype.$message = message;

window.git = process.env.VUE_APP_GIT

//注册'v-animate'  当元素出现在可视范围时添加类名触发动效样式
Vue.directive('animate', {
  inserted: function (el, binding) {
    // 聚焦元素
    binding.addClass = () => {
      const { top } = el.getBoundingClientRect()
      const h = document.documentElement.clientHeight || document.body.clientHeight
      if (top < h) {
        if (el.className.indexOf(binding.value) == -1) {
          // 初次还未绑定过，则新增类名(注意：下面单引号中间是一个空格！！！)
          el.className = binding.value + ' ' + el.className
        }
        if (binding.addClass) {
          window.removeEventListener('scroll', binding.addClass)
        }
      }
    }
    window.addEventListener('scroll', binding.addClass, true)
    binding.addClass()
  },
  unbind: function (el, binding) {
    if (binding.addClass) {
      window.removeEventListener('scroll', binding.addClass)
    }
  }
})


// 路由拦截器
// routerFilter(router)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js